import DynamicSectionElement from '@/scripts/dynamic-section-element.js'

class ProductModal extends DynamicSectionElement {
  constructor () {
    super()

    const MODAL_ACTIVE_CLASS = 'is-active'
    const OPEN_BUTTON_SELECTOR = '.js-open-bundle-modal'
    const CLOSE_BUTTON_SELECTOR = '.js-product-modal-close'
    const body = document.getElementsByTagName('body')[0]

    const closeButton = this.querySelector(CLOSE_BUTTON_SELECTOR)
    const openButtons = document.querySelectorAll(OPEN_BUTTON_SELECTOR)

    if (closeButton) {
      closeButton.onclick = function () {
        const parent = this.parentNode
        parent.classList.remove(MODAL_ACTIVE_CLASS)
        body.style = 'overflow: initial'

        if (openButtons.length) {
          openButtons.forEach(item => {
            item.classList.remove('open')
          })
        }
      }
    }
  }
}

customElements.define('product-modal', ProductModal)
